var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDotted1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "107.000000pt",
    height: "117.000000pt",
    viewBox: "0 0 107.000000 117.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,117.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M940 1104 c-37 -43 -37 -78 0 -82 35 -4 94 71 79 99 -15 29 -44 23 -79 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828 968 c-8 -7 -57 -62 -107 -121 -73 -87 -92 -114 -89 -135 2 -19 10 -28 24 -30 17 -2 44 23 121 115 54 65 102 126 106 135 3 10 0 24 -9 33 -19 18 -26 19 -46 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522 607 c-34 -35 -43 -81 -17 -91 23 -8 41 2 70 40 53 69 7 113 -53 51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307 354 c-59 -63 -107 -123 -107 -133 0 -18 18 -41 32 -41 15 0 98 82 165 162 68 81 79 120 38 126 -15 2 -49 -29 -128 -114z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 115 c-32 -30 -36 -38 -27 -55 16 -30 52 -24 89 14 65 67 8 106 -62 41z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotted1);
export default __webpack_public_path__ + "static/media/dotted_1.69dd8f3c.svg";
export { ForwardRef as ReactComponent };